import React from "react";
import LoginPage from "./LoginPage.tsx";
import {useAppSelector} from "../../hooks/reduxHooks.ts";

interface PrivateRouteProps {
    component: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({component}) => {
    const profile = useAppSelector(state => state.auth.profile);

    if (!profile) {
        return <LoginPage/>;
    }

    return <>{component}</>;
};

export default PrivateRoute;
